"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function UserDefault24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.07768 14.7986C6.22056 13.5399 5.00016 11.4125 5.00016 9C5.00016 5.13401 8.13417 2 12.0002 2C15.8662 2 19.0002 5.13401 19.0002 9C19.0002 11.4125 17.7798 13.5399 15.9226 14.7986C18.9033 16.0709 21.1402 18.7491 21.8001 22H19.7481C18.86 18.5495 15.7278 16 12.0002 16C8.27248 16 5.14028 18.5495 4.25219 22H2.2002C2.86009 18.7491 5.09702 16.0709 8.07768 14.7986ZM12.0002 14C14.7616 14 17.0002 11.7614 17.0002 9C17.0002 6.23858 14.7616 4 12.0002 4C9.23874 4 7.00016 6.23858 7.00016 9C7.00016 11.7614 9.23874 14 12.0002 14Z", fill: "#383F49" }));
}
function UserDefault24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(UserDefault24Svg, Object.assign({}, svgProps)));
}
exports.default = UserDefault24;
//# sourceMappingURL=UserDefault24.js.map